const l = (r, n, t) => {
  const e = r[n];
  return e ? typeof e == "function" ? e() : Promise.resolve(e) : new Promise((i, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      o.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + n + (n.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
export {
  l as default
};
